/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationreportreviewed2Inputs */

const en_moderationreportreviewed2 = /** @type {(inputs: Moderationreportreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Report reviewed`)
};

const de_moderationreportreviewed2 = /** @type {(inputs: Moderationreportreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meldung geprüft`)
};

/**
* | output |
* | --- |
* | "Report reviewed" |
*
* @param {Moderationreportreviewed2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationreportreviewed2 = /** @type {((inputs?: Moderationreportreviewed2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationreportreviewed2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationreportreviewed2(inputs)
	return de_moderationreportreviewed2(inputs)
});
export { moderationreportreviewed2 as "moderationReportReviewed" }